export default __webpack_public_path__ + "static/media/pouring-steamed-milk-bw.a1b39c41.jpg";